import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'section-header-strict',
  templateUrl: './section-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./section-header.component.scss'],
  standalone: false,
})
export class SectionHeaderComponent {
  @Input() valid = false;
  @Input() touched = false;
  @Input() tooltipText = '';
  @Input() compact = false;
  @Input() optional = false;
  @Input() optionalText = '';
}
